import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import ExamApply from '@/views/ExamApply.vue'
import ExamOnline from '@/views/ExamOnline.vue'
import ExamList from '@/views/ExamList.vue'
import ExamTimeInfo from '@/views/ExamTimeInfo.vue'
import ExaminerLogin from '@/views/ExaminerLogin.vue'
import ExamResultInfo from '@/views/ExamResultInfo.vue'
import MyEnroll from '@/views/MyEnroll.vue'
import EnrollDetails from '@/views/EnrollDetails.vue'
import AdmissionTicket from '@/views/AdmissionTicket.vue'
import MusicExam from '@/views/MusicExam.vue'
import TeachersList from '@/views/TeachersList.vue'
import ShopIndex from '@/views/ShopIndex.vue'
import VipCenter from '@/views/VipCenter.vue'
import Register from '@/views/Register.vue'
import ForgetPwd from '@/views/ForgetPwd.vue'
import NewsList from '@/views/NewsList.vue'
import NewsDetail from '@/views/NewsDetail.vue'
import AssessDetails from '@/views/AssessDetails.vue'
import Channels from '@/views/Channels.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      keepAlive: true
    }
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Login.vue'),
    meta: {
      title: "会员登录",
      img: "",
      digest: "",
      url: "/Login",
      BackUrl: "Home", //返回页面
      keepAlive: false
    },

  },
  {
    path: '/Register',
    component: Register,
    meta: {
      title: "会员注册",
      img: "",
      digest: "",
      url: "/Register",
      BackUrl: "Home", //返回页面
      keepAlive: false
    }
  },
  {
    path: '/ForgetPwd',
    component: ForgetPwd,
    meta: {
      title: "忘记密码",
      img: "",
      digest: "",
      BackUrl: "Home", //返回页面
      keepAlive: false
    },
  },
  {
    path: '/ExamCenter',
    name: 'ExamCenter',
    component: () => import('@/views/ExamCenter.vue'),
    meta: {
      title: "考级中心",
      img: "",
      digest: "",
      url: "",
      keepAlive: false
    }
  },

  {
    path: '/connect',
    name: 'connect',
    component: () => import('@/views/connect.vue'),
    meta: {
      title: "联系我们",
      img: "",
      digest: "",
      url: "",
      keepAlive: false
    }
  },
  {
    path: '/ExamApply',
    component: ExamApply,
    meta: {
      title: "在线报名",
      img: "",
      digest: "",
      url: "/ExamApply",
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/ExamOnline',
    component: ExamOnline,
    meta: {
      title: "在线考试",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/ExamList',
    component: ExamList,
    meta: {
      title: "在线考试",
      img: "",
      digest: "",
      url: "/ExamList",
      isAuth: true, //是否需要鉴权
      keepAlive: true
    }
  },
  {
    path: '/ExamTimeInfo',
    component: ExamTimeInfo,
    meta: {
      title: "查询考场",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权
      keepAlive: true
    }
  },
  {
    path: '/ExamResultInfo',
    component: ExamResultInfo,
    meta: {
      title: "考试成绩",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权
      keepAlive: true
    }
  },
  {
    path: '/ExaminerLogin',
    component: ExaminerLogin,
    meta: {
      title: "考官登录",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/MyEnroll',
    component: MyEnroll,
    meta: {
      title: "我的报名",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/EnrollDetails',
    component: EnrollDetails,
    meta: {
      title: "报名详情",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/AdmissionTicket',
    component: AdmissionTicket,
    meta: {
      title: "考官评审",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/ReviewResults',
    component: () => import('@/views/ReviewResults.vue'),
    meta: {
      title: "评审成绩",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权
      keepAlive: false,
    }
  },
  {
    path: '/MusicExam',
    name: 'MusicExam',
    component: MusicExam,
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权.
      keepAlive: false
    }
  },
  {
    path: '/TeachersList',
    name: 'TeachersList',
    component: TeachersList,
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      keepAlive: false
    }
  },
  {
    path: '/ShopIndex',
    name: 'ShopIndex',
    component: ShopIndex,
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      keepAlive: false
    }
  },
  {
    path: '/VipCenter',
    name: 'VipCenter',
    component: VipCenter,
    meta: {
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/ExamTimeList',
    name: 'ExamTimeList',
    component: () => import('@/views/ExamTimeList.vue'),
    meta: {
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/OnSiteReview',
    name: 'OnSiteReview',
    component: () => import('@/views/Scene/OnSiteReview.vue'),
    meta: {
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/ReviewInfo',
    name: 'ReviewInfo',
    component: () => import('@/views/Scene/ReviewInfo.vue'),
    meta: {
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  }
  ,
  {
    path: '/SetOfflineExamTracks',
    name: 'SetOfflineExamTracks',
    component: () => import('@/views/Scene/SetOfflineExamTracks.vue'),
    meta: {
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/FireworksClient',
    name: 'FireworksClient',
    component: () => import('@/views/FireworksClient.vue'),
    meta: {
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/ExamTimeUserList',
    name: 'ExamTimeUserList',
    component: () => import('@/views/ExamTimeUserList.vue'),
    meta: {
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/NewsList',
    component: NewsList,
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      keepAlive: false
    }
  },
  {
    path: '/Channels',
    component: Channels,
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      keepAlive: false
    }
  },
  {
    path: '/NewsDetail',
    component: NewsDetail,
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      keepAlive: false
    }
  },
  {
    path: '/Assessment',
    component: () => import('@/views/Assessment.vue'),
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      keepAlive: true
    }
  },
  {
    path: '/AssessDetails',
    component: AssessDetails,
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      keepAlive: false
    }
  },
  {
    path: '/ExamOtherResultInfo',
    component: () => import('@/views/ExamOtherResultInfo.vue'),
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/SingReview',
    component: () => import('@/views/SingReview.vue')
  },
  {
    path: '/Video',
    component: () => import('@/views/Video.vue')
  },
  {
    path: '/MIReview',
    component: () => import('@/views/MIReview.vue')
  },
  {
    path: '/Answerkey',
    component: () => import('@/views/Hearing/Answerkey.vue'),
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/ReviewHearing',
    component: () => import('@/views/Hearing/ReviewHearing.vue'),
    meta: {
      title: "",
      img: "",
      digest: "",
      url: "",
      isAuth: true, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('@/views/agreement/service.vue'),
    meta: {
      isAuth: false, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/agreement/privacy.vue'),
    meta: {
      isAuth: false, //是否需要鉴权
      keepAlive: false
    }
  },
  {
    path: '/404',
    component: () => import('@/views/404.vue')
  },
  {
    path: "*",
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
